import styled, { css } from 'styled-components';

import {
    MdDashboard,
    MdExitToApp,
    MdChecklist,
    MdAccessTime
} from 'react-icons/md';

import {
    ImHome
} from 'react-icons/im';

import {
    BiSupport
} from 'react-icons/bi';

import {
    GrUserAdmin
} from 'react-icons/gr';

interface IContainerProps {
    menuIsOpen: boolean;
}

export const Container = styled.div`
    grid-area: AS;
    
    /* padding-left: 20px; */
    border-right: 1px solid gray;

    position: relative;
    transition: all 0.5s;
    
`;

export const Header = styled.header`
    height: 70px;
    
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;



export const MenuContainer = styled.nav`
    display: flex;
    flex-direction: column;
`;

export const MenuItemLink = styled.div<IContainerProps>`
    display: flex;
    align-items: center;

    margin-right: 5px;
    padding-left: 5px;
    border-radius: 5px;

    transition: opacity .3s;
    &:hover {
        opacity: .7;
        background-color: #d1d1d1;
    }

    ${props => !props.menuIsOpen && css`
        /* margin: 0 auto 10px; */
        /* width: 50%; */
        margin-right: 5px;
        margin-bottom: 10px;
        padding: 7px 7px 7px 7px;

        > h3 {
            display: none;
        }

        > p {
            display: none;
        }
    `};
    
`;

export const MenuItemButton = styled.button`
    font-size: 16px;
    color: #f7931b;
    
    border: none;
    background: none;

    margin: 7px 0;
    display: flex;

    transition: opacity .3s;

    &:hover {
        opacity: .7;
    }
`;

export const ToggleMenu = styled.button`
    width: 30px;
    height: 30px;

    border-radius: 5px;

    font-size: 22px;
    color: black;

    transition: opacity .3s;

    display: flex;
    justify-content: center;
    align-items: center;

    &:hover{
        opacity: 0.7;
    }
`;

export const Menu = styled.div`

    height: calc(100vh - 70px);

    display: flex;
    flex-direction: column;

    justify-content: space-between;
    
`;

export const DashBoardIcon = styled(MdDashboard)`
    width: 25px;
    height: 25px;

    border-radius: 3px;

    padding-right: 5px;

    cursor: pointer;

    &:hover {
        opacity: .7;
    }
`;

export const MdAccessTimeIcon = styled(MdAccessTime)`
    width: 25px;
    height: 25px;

    border-radius: 3px;

    padding-right: 5px;

    cursor: pointer;

    &:hover {
        opacity: .7;
    }
`;

export const MdChecklistIcon = styled(MdChecklist)`
    width: 25px;
    height: 25px;

    border-radius: 3px;

    padding-right: 5px;

    cursor: pointer;

    &:hover {
        opacity: .7;
    }
`;

export const HomeIcon = styled(ImHome)`
    width: 25px;
    height: 25px;

    border-radius: 3px;

    padding-right: 5px;

    cursor: pointer;

    &:hover {
        opacity: .7;
    }

`;

export const BiSupportIcon = styled(BiSupport)`
    width: 25px;
    height: 25px;

    border-radius: 3px;

    padding-right: 5px;

    cursor: pointer;

    &:hover {
        opacity: .7;
    }
`;

export const AdminIcon = styled(GrUserAdmin)`
    width: 25px;
    height: 25px;

    border-radius: 3px;

    padding-right: 5px;

    cursor: pointer;

    &:hover {
        opacity: .7;
    }
`;

export const ExitIcon = styled(MdExitToApp)`
    width: 25px;
    height: 25px;

    border-radius: 3px;

    padding-right: 5px;

    cursor: pointer;

    &:hover {
        opacity: .7;
    }
`;